export const state = () => ({
  time: null,
  message: null,
  color: null,
  // レイアウトを跨いで出す通知か（components/util/Alert.vue がマウント時にも出す）。
  // ログアウト理由のように、通知を立てた直後にレイアウトが切り替わるものだけ true
  acrossLayout: false,
})
export const getters = {
  getTime(state) {
    return state.time
  },
}
// 同じ message の繰り返し（ログアウト理由の直後に画面側が同じ message で setError を重ねる等）なら、
// レイアウトを跨ぐ扱いを消さない。別の通知に替わったら跨がない（C9）
const keepAcrossLayout = (state, message) => !!state.acrossLayout && state.message === message

export const mutations = {
  setInfo(state, message) {
    state.acrossLayout = keepAcrossLayout(state, message)
    state.time = Date.now()
    state.message = message
    state.color = "secondary"
  },
  setSuccess(state, message) {
    state.acrossLayout = keepAcrossLayout(state, message)
    state.time = Date.now()
    state.message = message
    state.color = "success"
  },
  setError(state, message){
    state.acrossLayout = keepAcrossLayout(state, message)
    state.time = Date.now()
    state.message = message
    state.color = "red"
  },
  // ログアウトの理由（「認証されていない端末です」等）。直後にログイン画面（layout: logout）へ
  // 切り替わり Alert が作り直されるため、作り直し後も出す（C9）
  setLogoutReason(state, message){
    state.time = Date.now()
    state.message = message
    state.color = "red"
    state.acrossLayout = true
  }
}
